import { useEffect, useState, useContext } from "react";
import { differenceInCalendarDays, parseISO, format, isSameDay, addDays } from "date-fns";
import IndividualStaff from "../manager/individalstaff";
import ViewAppraisal from "../manager/viewappraisals";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";


import { ArrowDownIcon } from "@heroicons/react/20/solid";

export default function StaffDetails() {
  const [staffSummary, setStaffSummary] = useState([]);
  const [policies, setPolicies] = useState(null);
  const [staffIndividualName, setStaffIndividualName] = useState(null); // Renamed to avoid conflict
  const [staffIndividualNow, setStaffIndividualNow] = useState(null);
  const [staffIndividualDocs, setStaffIndividualDocs] = useState(null);
  const [staffDocuments, setStaffDocuments] = useState(null);
  const [edit, setEdit] = useState(null);
  const [issue, setIssue] = useState(false);

  const navigate = useNavigate();

  const user =  useContext(AuthContext);
  const token = localStorage.getItem('token');

  console.log(staffIndividualName); // Debugging output

  useEffect(() => { 
    const getDisciplinary = async () => {
      const response = await fetch("https://api.insightos.co.uk/api/alldisciplinary", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials : 'include',


      });

      if (!response.ok) {
        console.error("Failed to fetch data");
        return;
      }

      const { data: disciplinary } = await response.json();

      console.log(disciplinary);

      // Check if the staff individual is selected and fetch the data
      
    }

    getDisciplinary();


  }, []); // This runs when `staffIndividualName` changes
    

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://api.insightos.co.uk/api/staffpolicy", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials : 'include',

        });

        const { success, clockins, holiday, staff, data: policies, shifts } =
          await response.json();

        if (!success) {
          console.error("Failed to fetch data");
          return;
        }

        setPolicies(policies[0]); // Assuming there's only one set of policies

        // Process each staff member
        const summary = staff.map((staffMember) => {
          const staffId = staffMember.id;

          // Calculate sick days and sick occasions
          const sickDates = shifts
            .filter((c) => c.StaffId === staffId && c.Sick === 1)
            .map((c) => parseISO(c.ShiftDate)); // Assuming there's a `Date` field in `clockins`

          let sickOccasions = 0;
          if (sickDates.length > 0) {
            sickDates.sort((a, b) => a - b); // Sort dates
            sickOccasions = 1; // At least one sick occasion if there are sick days

            for (let i = 1; i < sickDates.length; i++) {
              const prevDate = sickDates[i - 1];
              const currentDate = sickDates[i];

              // If the current date is not consecutive to the previous date, increment the occasion count
              if (!isSameDay(currentDate, addDays(prevDate, 1))) {
                sickOccasions++;
              }
            }
          }

          const sickDays = sickDates.length;

          // Calculate late occasions
          const lateOccasions = clockins.filter(
            (c) => c.StaffId === staffId && c.Late === 1
          ).length;


        // calculate salary for staff member
        const hourlyRate = staffMember.HourlyRate;
        const contractHours = staffMember.ContractedHours; // Hours per week
        
        // Yearly salary
        const yearlySalary = hourlyRate * contractHours * 52; 
        
        // Monthly salary
        const monthlySalary = yearlySalary / 12; 
        
        // Weekly salary
        const weeklySalary = hourlyRate * contractHours;
        





          
          // Calculate holidays booked
          const holidaysForStaff = staffMember.HolidayTaken

          const holidayDays = holidaysForStaff;

          const holidayAllowance = staffMember.HolidayEntitlement;


// get the OpenDays from the policies 



          // Extract and format Last Appraisal
          const lastAppraisal = staffMember.LastAppraisal
            ? format(parseISO(staffMember.LastAppraisal), "dd/MM/yyyy")
            : "No Data";

          // Convert Probation status
          const probationStatus = staffMember.Probation === 1 ? "Yes" : "No";

          return {
            Name: staffMember.Name,
            SickDays: sickDays,
            SickOccasions: sickOccasions,
            LateOccasions: lateOccasions,
            HolidayDays: holidayDays,
            HolidayAllowance : holidayAllowance,
            LastAppraisal: lastAppraisal,
            ProbationStatus: probationStatus,
            id: staffMember.id,
            YearlySalary: yearlySalary,
            MonthlySalary: monthlySalary,
            WeeklySalary: weeklySalary,
            HourlyRate: hourlyRate,
            ContractedHours: contractHours,
            ContractedDays : staffMember.ContractedDays,
          };
        });

        setStaffSummary(summary);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []); // Runs once when component mounts

  useEffect(() => {
    const getStaff = async () => {

      const token = localStorage.getItem('token');

      const response = await fetch("https://api.insightos.co.uk/api/staff", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials : 'include',

      });

      if (!response.ok) {
        console.error("Failed to fetch data");
        return;
      }

      const { data: staff } = await response.json();

      // Check if the staff individual is selected and fetch the data
      const selectedStaff = staff.find((staffMember) => staffMember.Name === staffIndividualName);

      console.log(selectedStaff);

      if (selectedStaff) {
        setStaffIndividualNow(selectedStaff);
      } else {
        console.error("Staff not found");
      }
    };

    if (staffIndividualName) {
      getStaff();
    }

  }, [staffIndividualName]); // This runs when `staffIndividualName` changes

  console.log(staffIndividualDocs); // Debugging output
    
  useEffect(() => {
    const getStaff = async () => {

      const token = localStorage.getItem('token');

      const response = await fetch("https://api.insightos.co.uk/api/staff", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials : 'include',

      });

      if (!response.ok) {
        console.error("Failed to fetch data");
        return;
      }

      const { data: staff } = await response.json();

      console.log(staff);

      // Check if the staff individual is selected and fetch the data
      const selectedStaff = staff.find((staffMember) => staffMember.Name === staffIndividualDocs);

      console.log(selectedStaff);


      if (selectedStaff) {
        setStaffDocuments(selectedStaff);
      } else {
        console.error("Staff not found");
      }
    };

    if (staffIndividualDocs) {
      getStaff();
    }

  }, [staffIndividualDocs]); 


  
  if (edit) {
    navigate( "/viewappraisal", { state: { id: edit } });
    
  }




  // Render IndividualStaff component if data is available
  if (staffIndividualNow) {
    return <IndividualStaff staff={staffIndividualNow} />;
  }

  if (staffIndividualDocs) {

    // staffdocuments is an object i just need the id


    return <ViewAppraisal id={staffDocuments} />;
  }


  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold text-gray-900">Staff Summary</h1>
          <p className="mt-2 text-sm text-gray-700">
            View details for all staff, including their adherence to company policies.
          </p>
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Name
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Role
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Sick Days
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Sick Occasions
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Late Occasions
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Holiday Hours
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Hourly Rate
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Contracted Hours
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Contracted Days
                  </th>

                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Weekly Salary
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Monthly Salary
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Yearly Salary
                  </th>


                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Last Appraisal
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Probation Status
                  </th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {staffSummary.map((staff, index) => (
                  <tr key={index}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                      {staff.Name}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {staff.Role}
                    </td>

                    {/* Sick Days */}
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <div className="flex items-center">
                        <span className="mr-2">{staff.SickDays}</span>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 mr-3">
                          <div
                            className={`h-2.5 rounded-full ${
                              staff.SickDays > policies.SickDays
                                ? "bg-red-600"
                                : "bg-green-500"
                            }`}
                            style={{
                              width: `${(staff.SickDays / policies.SickDays) * 100}%`,
                            }}
                          />
                        </div>
                        {staff.SickDays > policies.SickDays && (
                          <button onClick={() => navigate('/appraisals')} className="rounded bg-red-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                            Raise Issue
                          </button>
                        )}
                      </div>
                    </td>

                    {/* Sick Occasions */}
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-black">
                      {staff.SickOccasions}
                    </td>

                    {/* Late Occasions */}
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <div className="flex items-center">
                        <span className="mr-2 text-bold text-black">{staff.LateOccasions}</span>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 mr-3">
                          <div
                            className={`h-2.5 rounded-full ${
                              staff.LateOccasions > policies.LateOccasions
                                ? "bg-red-600"
                                : "bg-green-500"
                            }`}
                            style={{
                              width: `${(staff.LateOccasions / policies.LateOccasions) * 100}%`,
                            }}
                          />
                        </div>
                        {staff.LateOccasions > policies.LateOccasions && (
                          <button onClick={() => navigate('/appraisals')}  className="rounded bg-red-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                            Raise Issue
                          </button>
                        )}
                      </div>
                    </td>

                    {/* Holiday Days */}
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {staff.HolidayDays} / {staff.HolidayAllowance}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      £{staff.HourlyRate.toFixed(2)}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {staff.ContractedHours}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {staff.ContractedDays}
                    </td>
                    

                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
  £{staff.WeeklySalary.toFixed(2)}
</td>
<td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
  £{staff.MonthlySalary.toFixed(2)}
</td>
<td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
  £{staff.YearlySalary.toFixed(2)}
</td>

                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {staff.LastAppraisal}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {staff.ProbationStatus}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <div className="relative">
                    <select
    defaultValue=""
    onChange={(e) => {
      const action = e.target.value;
      console.log(action); // Debugging output
      if (action === "details") setStaffIndividualName(staff.Name);
      if (action === "docs") setStaffIndividualDocs(staff.Name);
      if (action === "edit") setEdit(staff.id);
      // Reset select to default after action
      e.target.value = "";
    }}
    className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
  >
    <option value="" disabled>Select Action</option>
    <option value="details">View Individual Details</option>
    <option value="docs">View Appraisals</option>
  </select>
</div>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
